import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bdc0f288&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "styles/views/index/hotshop.css?vue&type=style&index=0&id=bdc0f288&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdc0f288",
  null
  
)

export default component.exports